import React, { useState } from 'react';

const DiscountCodes = () => {
  const [discountType, setDiscountType] = useState('standard');
  const [discountAmountType, setDiscountAmountType] = useState('percent');
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [formData, setFormData] = useState({
    promoCode: '',
    discountAmount: '',
    payoutMethod: 'per-ticket',
    payoutAmount: '',
    contactPhone: '',
    customerDiscount: '',
    limitTotal: false,
    totalLimit: '',
    onePerCustomer: false,
    expiration: 'noExpiration',
    expirationDate: '',
    eventTarget: 'allEvents',
    schedule: 'createNow',
    scheduleDate: '',
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleDiscountTypeToggle = (type) => {
    setDiscountType(type);
  };

  const handleDiscountAmountTypeToggle = (type) => {
    setDiscountAmountType(type);
  };

  const toggleAdvanced = () => {
    setShowAdvanced(!showAdvanced);
  };

  const createDiscount = (e) => {
    e.preventDefault();

    if (!formData.promoCode.trim()) {
      alert('Please enter a promo code name');
      return;
    }

    // Here you would normally submit the form data
    // eslint-disable-next-line no-console
    console.log('Creating discount with data:', formData);
    alert('Discount created successfully! (This is a demo)');
  };

  return (
    <div className="mobile-container">
      {/* Page Header */}
      <div className="page-header">
        <h1 className="page-title">Create New Discount</h1>
        <p className="page-subtitle">Choose the type of discount to create</p>
      </div>

      {/* Type Selection */}
      <div className="type-selection">
        <div className="type-toggle">
          <button
            className={`type-option ${
              discountType === 'standard' ? 'active' : ''
            }`}
            onClick={() => handleDiscountTypeToggle('standard')}
          >
            Standard
          </button>
          <button
            className={`type-option ${
              discountType === 'referral' ? 'active' : ''
            }`}
            onClick={() => handleDiscountTypeToggle('referral')}
          >
            Referral
          </button>
        </div>
      </div>

      {/* Form Container */}
      <form
        className={`form-container type-${discountType}`}
        onSubmit={createDiscount}
      >
        <div className="form-header">
          <h2 className="form-header-title">Discount Details</h2>
        </div>

        <div className="form-body">
          {/* Promo Code Name */}
          <div className="form-group">
            <label className="form-label" htmlFor="promoCode">
              Promo Code Name <span className="required">*</span>
            </label>
            <input
              id="promoCode"
              type="text"
              className="form-input promo-code-input"
              placeholder="SUMMER25"
              name="promoCode"
              value={formData.promoCode}
              onChange={handleInputChange}
            />
            <div className="input-hint">
              What customers will type at checkout
            </div>
          </div>

          {/* Standard Discount Amount */}
          {discountType === 'standard' && (
            <div className="form-group standard-only">
              <label className="form-label" htmlFor="discountAmount">
                Discount Amount <span className="required">*</span>
              </label>
              <div className="discount-input-group">
                <input
                  id="discountAmount"
                  type="number"
                  className="discount-input"
                  placeholder="10"
                  min="0"
                  name="discountAmount"
                  value={formData.discountAmount}
                  onChange={handleInputChange}
                />
                <div className="discount-type-toggle">
                  <button
                    type="button"
                    className={`discount-type-btn ${
                      discountAmountType === 'dollar' ? 'active' : ''
                    }`}
                    onClick={() => handleDiscountAmountTypeToggle('dollar')}
                  >
                    $
                  </button>
                  <button
                    type="button"
                    className={`discount-type-btn ${
                      discountAmountType === 'percent' ? 'active' : ''
                    }`}
                    onClick={() => handleDiscountAmountTypeToggle('percent')}
                  >
                    %
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Advanced Options Toggle */}
          <button
            type="button"
            className="advanced-toggle"
            onClick={toggleAdvanced}
            aria-expanded={showAdvanced}
          >
            <span className="advanced-toggle-text">
              {showAdvanced ? 'Hide' : 'Show'} Advanced Options
            </span>
          </button>

          {/* Create Button */}
          <div className="bottom-actions">
            <button type="submit" className="create-button">
              Create Discount
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DiscountCodes;
